import React, { useEffect, useState } from 'react'
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { useQueryClient } from '@tanstack/react-query';
import BlueButton from '../components/BlueButton';
import { _FETCH, _FETCH_POST } from '../utils/patches';
import { useQuery } from '@tanstack/react-query';
import Loading from '../whitaijiFrontendLibrary/components/Loading';
import HandFontRichTextEditor from '../whitaijiFrontendLibrary/textEditors/HandFontTextEditor';
import RichTextEditor from '../whitaijiFrontendLibrary/textEditors/RichTextEditor';
import EmojiRating from '../components/EmojiRating';
import VisDiv from '../components/VisDiv';
import { goldColour, lighterBlueColour, Tag } from './Home';
import SmallMusicPlayer from '../components/SmallMusicPlayer';
import { BsDisplay } from 'react-icons/bs';
import { ConcertInfo } from './Concert';
import T, { dT } from '../components/Translation';
import format from 'date-fns/format'
import { useNavigate } from 'react-router-dom';
import { CustomSection } from '../components/Journal';

const JournalEntry = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const {hideTestButtons, apiUrl, language, } = useStateContext()
        const journalEntryId = urlParams.get('_id');

        const {user} = useAuthContext(AuthContext)
        
        const navigate = useNavigate()
        
        const { data: journalEntryData={},  isLoading: isLoadingJournalEntryData } = useQuery({
          queryKey: ['journalEntry', journalEntryId],
          enabled: !!journalEntryId && !!apiUrl,
          queryFn: async () => {
              const concerts = await _FETCH({
                route: `${apiUrl}/journal-entries/${journalEntryId}`,
                user
              });
              return concerts;
            }
        });
             useEffect(() => {
              if (!journalEntryId) {
                navigate('/')
              }
            }, [journalEntryId])
        const {title, journalEntryEditorDoc, rating, concertLogId, songId, songTitle, customSections, concertTitle} = journalEntryData

        const { data: songData={},  isLoading: isLoadingSongData } = useQuery({
          queryKey: ['song', journalEntryId],
          enabled: !!songId && !!apiUrl,
          queryFn: async () => {
              const song = await _FETCH({
                route: `${apiUrl}/songs/${songId}`,
                user
              });
              return song;
            }
        });

        const { data: concertLogData={},  isLoading: isLoadingConcertLogData } = useQuery({
          queryKey: ['concertLog', journalEntryId],
          enabled: !!concertLogId && !!apiUrl,
          queryFn: async () => {
              const concertLog = await _FETCH({
                route: `${apiUrl}/concert-logs/${concertLogId}`,
                user,
                //onSuccess: () => {console.log("concertLogData", concertLogData)}
              });
              return concertLog;
            }
        });
        const { data: concertData={},  isLoading: isLoadingConcertData } = useQuery({
          queryKey: ['concertData', journalEntryId],
          enabled: !!concertLogData?.concertId && !!apiUrl,
          queryFn: async () => {
              const concert = await _FETCH({
                route: `${apiUrl}/concerts/${concertLogData?.concertId}`,
                user
              });
              return concert;
            }
        });
            const songIdsToLoad = !Array.isArray(concertData?.songs) ? [] : concertData?.songs?.map((song) => song.songTemplateId);
        
            const { data: songs, isLoading: isLoadingSongs } = useQuery({
                queryKey: ['songs', songIdsToLoad],
                enabled: !!songIdsToLoad.length && !!apiUrl,
                queryFn: async () => {
                    const songs = await _FETCH_POST({
                        route: `${apiUrl}/concerts/songs/byIds`,
                        body: { songIds: songIdsToLoad },
                        user
                    });
                    return songs;
                }
            });

    const songsToPlayer = !Array.isArray(songs) ? [] : songs
      ?.map((song) => {
        const songInConcert = !Array.isArray(concertData?.songs) ? undefined : concertData?.songs?.find((item) => item?.songTemplateId == song?._id)
        return {
          ...song, 
          order: songInConcert?.order,
          lyricsToHighlight: songInConcert?.lyrics?.filter((lyric) => lyric?.status !== "archived"),  
          affirmation: songInConcert?.affirmation,
          status: songInConcert?.status,
          isWithPrelude: song?.isWithPrelude,
          imageUrl: `https://remind-public.s3.eu-north-1.amazonaws.com/images/${song?.imageName}.png`,
          songInConcertId: songInConcert?._id,
          aiVoSource: `https://remind-public.s3.eu-north-1.amazonaws.com/aivo/${songInConcert?._id}.mp3`,
          
        }
        })
      ?.filter((song) => song?.status !== "archived")
      ?.sort((a, b) => a?.order - b?.order)

        const testFunction = () => {
            console.log("ksnxjksnxc", {journalEntryData, journalEntryData, songData, concertLogData, concertData})
        }

    const navigateToConcert = () => {
      window.open(`${window.location.origin}/concert?_id=${concertData?._id}`, "_self" )
    }
 if(isLoadingJournalEntryData || isLoadingSongData || isLoadingConcertLogData || isLoadingConcertData || isLoadingSongs) return <Loading />
  return (
    <div>
        <BlueButton fn = {testFunction} hide={hideTestButtons}/>
        <BlueButton text="Back To Journal" navigateTo="/my-journal" hide={false}/>
        <div style={{padding:"15px", textAlign:"center"}}><h1 style={{fontFamily: "'Caveat', cursive", fontSize:"35px"}}>{title}</h1></div>
        <div>
            <VisDiv style={{marginBottom:"10px", marginLeft:"10px"}} rules={[songTitle]}>
                <Tag text={songTitle}/>
            </VisDiv>
            <VisDiv style={{margin:"10px"}} rules={[concertTitle]}>
                <Tag color={lighterBlueColour} text={concertTitle} />
            </VisDiv>
        </div>
        <EmojiRating readOnly={true} initialRating={rating} />
        <div style={{padding:"0px 25px 25px 25px"}}>
            <RichTextEditor noFocus={true} existingDoc={journalEntryEditorDoc} readOnly={true} updateInitialData={true}/> 
        </div>
        <VisDiv style={{display:"flex", alignItems:"center", justifyContent:"center", padding:"10px"}} rules={[songData?.soundSource]}>
            <SmallMusicPlayer
                containerStyle={{maxWidth: "95%"}}
                secondsOnly={false}
                songSource = {songData?.soundSource}
                title={songData?.title}
                lyrics={songData?.lyrics}
            />
        </VisDiv>
          {customSections?.map((customSection, index)=>{
              return(
                  <CustomSection 
                      edit={false}
                      key={customSection?._id} 
                      //setCustomSections={setCustomSections} 
                      customSections={customSections} 
                      customSection={customSection}
                      index={index}
                  />
              )})}
        <VisDiv rules={[concertData?._id]}>
            <div style={{display:"flex", justifyContent:"center", textAlign:"center", color:goldColour, margin:"20px"}}>
                <h1>{concertData?.title}</h1>
            </div>
            <VisDiv rules={[concertLogData?._id]}>
                <ConcertLogReport concertLogData={concertLogData} />
            </VisDiv>
            <ConcertInfo songsToPlayer = {songsToPlayer} concert={concertData} viewInfo={true} />
            <VisDiv style={{display:"flex", alignItems:"center", justifyContent:"center", padding:"10px"}} rules={[songsToPlayer]}>
{/*                 <SmallMusicPlayer
                    containerStyle={{maxWidth: "95%"}}
                    secondsOnly={false}
                    songs={songsToPlayer}

                /> */}
                <BlueButton text={dT({en:"Play Concert", it:"Vai al Concerto"}, language)} fn={navigateToConcert} hide={false}/>
            </VisDiv>
        </VisDiv>
    </div>
  )
}

export default JournalEntry

export const ConcertLogReport = ({hideTitle, concertLogData = {}}) => {
    //const [concertLog, setConcertLog] = useState(concertLogData)

    const {
      concertId,
      concertTitle,
      user_id,
      status,
      startFeedback,
      endFeedback,
      currentSongId,
      completedOn,
      createdAt,
      } = concertLogData
    const startDate = createdAt && format(new Date(createdAt), "dd/MM/yyyy HH:mm");
    const endDate = completedOn && format(new Date(completedOn), "dd/MM/yyyy HH:mm");
    const testFunction = () => {
        console.log("ksnxjksnxc", {concertLogData})
    }
    return (
        <VisDiv style={{marginBottom:"10px", marginLeft:"12px"}} rules={[concertLogData]}>
            <VisDiv rules={[!hideTitle]} style={{display:"flex", alignItems:"center", justifyContent:"center", padding:"10px"}}>
                <h2 style={{color:goldColour}}>
                    <T obj={{en: "Concert Report", it: "Report Concerto"}}/>
                </h2>
            </VisDiv>
            <ReportLine visible={startDate} label={<T obj={{en: "Start Date", it: "Data Inizio"}}/>} value={startDate} />
            <ReportLine visible={startFeedback} label={<T obj={{en: "Start Feedback", it: "Feedback Inizio"}}/>} value={`${startFeedback} / 10`} />
            <ReportLine visible={endDate} label={<T obj={{en: "End Date", it: "Data Fine"}}/>} value={endDate} />
            <ReportLine visible={endFeedback} label={<T obj={{en: "End Feedback", it: "Feedback Fine"}}/>} value={`${endFeedback} / 10`} />
            <ReportLine visible={endFeedback && startFeedback} label={<T obj={{en: "Improvement", it: "Miglioramento"}}/>} value={endFeedback - startFeedback} />
            
        </VisDiv>
    )
}

export const ReportLine = ({label, value, justifyContent="left", visible}) => {
    return (
        <VisDiv rules={[visible]} style={{display:"flex", justifyContent, padding: "10px", borderBottom: "1px solid #ccc", margin: "5px 0"}}>
            <div>{label}:</div>
            <div style={{fontWeight:"bold", marginLeft: "10px"}}>{value}</div>
        </VisDiv>
    )   
}